
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { User, Mail, Phone } from "lucide-react";

interface PersonalInfoSectionProps {
  profile: {
    full_name: string;
    email: string;
    phone: string;
  };
  onInputChange: (field: string, value: string) => void;
  onSave: () => void;
  saveLoading: boolean;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  profile,
  onInputChange,
  onSave,
  saveLoading
}) => {
  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    onSave();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-right flex items-center gap-2">
          <User className="h-5 w-5 text-blue-600" />
          البيانات الشخصية
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSave} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label className="text-right block mb-2 flex items-center gap-2">
                <User className="h-4 w-4" />
                الاسم الكامل
              </Label>
              <Input
                value={profile.full_name}
                onChange={(e) => onInputChange('full_name', e.target.value)}
                placeholder="اسمك الكامل"
                className="text-right"
              />
            </div>
            
            <div>
              <Label className="text-right block mb-2 flex items-center gap-2">
                <Phone className="h-4 w-4" />
                رقم الهاتف
              </Label>
              <Input
                value={profile.phone}
                onChange={(e) => onInputChange('phone', e.target.value)}
                placeholder="رقم الجوال"
                className="text-right"
              />
            </div>
          </div>

          <div>
            <Label className="text-right block mb-2 flex items-center gap-2">
              <Mail className="h-4 w-4" />
              البريد الإلكتروني
            </Label>
            <Input
              type="email"
              value={profile.email}
              onChange={(e) => onInputChange('email', e.target.value)}
              placeholder="البريد الإلكتروني"
              className="text-right"
            />
          </div>

          <Button type="submit" disabled={saveLoading} className="w-full">
            {saveLoading ? "جارٍ الحفظ..." : "حفظ البيانات الشخصية"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default PersonalInfoSection;
